import {AlternativeTemplate, emptyEffects} from "app/types/model-types"
import {projectId} from "app/helpers/api"
import { defaultTemplateSize } from "shape-edit/forms/helpers"

export default function() : AlternativeTemplate {
    return {
        id: null,
        project_id: projectId,
        size: defaultTemplateSize,
        size_id: null,
        is_keep_size: null,
        priority: null,
        enlarge: 1,
        flip: 0,
        flop: 0,
        rotation: 0,
        name: null,
        type: null,
        background: '#ffffff',
        background_type: null,
        background_colors: null,
        background_gradient_ids: null,
        alpha: 0,
        gradient_id: null,
        active: 1,
        translate_x: 0,
        translate_y: 0,
        enlarge_by: 'fit',
        overscan: 0,
        outpaint_over: 0,
        effect_id: null,
        has_reflection: null,
        reflection_angle: null,
        reflection_offset: null,
        reflection_opacity: null,
        shadow_color: null,
        shadow_opacity: null,
        shadow_sigma: null,
        shadow_xoffset: null,
        shadow_yoffset: null,
        max_image_width: null,
        max_image_height: null,
        is_autocrop: null,
        created_at: null,
        updated_at: null,
        gradient: null,
        gradients: null,
        shapes: [],
        effects: {...emptyEffects, project_id: projectId},
        queries: [],
        groups: [],
        active_from: null,
        active_to: null,
        is_collage: 0,
        collage_layout_id: null,
        crop: 0,
        is_anim_gif: null,
        frames_delay: null,
        loops_delay: null,
        watermark_group_id: null,
        inpainting_group_id: null,
        min_detection_accuracy: null,
        collage_all_available_only: null,
    }
}
